/**
 * Escolhe política canônica do frontend quando a API ainda está desatualizada
 * (ex.: backend de produção sem redeploy).
 *
 * Compara versões semver simples (major.minor) e rejeita conteúdo legado.
 */
export function parseVersion(v) {
  if (!v || typeof v !== 'string') return [0, 0];
  const parts = v.trim().split('.').map((n) => parseInt(n, 10) || 0);
  return [parts[0] || 0, parts[1] || 0];
}

export function isVersionAtLeast(actual, minimum) {
  const [aMaj, aMin] = parseVersion(actual);
  const [mMaj, mMin] = parseVersion(minimum);
  if (aMaj !== mMaj) return aMaj > mMaj;
  return aMin >= mMin;
}

export function isStaleLegalContent(content) {
  if (typeof content !== 'string') return true;
  return (
    content.includes('2024-01-01') ||
    content.includes('Data de atualização: 2024') ||
    /Versão:\s*1\.0\s*$/m.test(content)
  );
}

/**
 * @param {object|null} apiData resposta da API (já unwrapped)
 * @param {object} fallback conteúdo canônico do bundle
 * @param {string} minVersion versão mínima aceitável da API
 */
export function resolveLegalPolicy(apiData, fallback, minVersion) {
  if (!apiData || typeof apiData !== 'object') {
    return fallback;
  }
  const versionOk = isVersionAtLeast(apiData.version, minVersion);
  const contentOk = !isStaleLegalContent(apiData.content);
  if (versionOk && contentOk && apiData.content) {
    return {
      ...apiData,
      acceptance_required:
        apiData.acceptance_required ?? fallback.acceptance_required,
    };
  }
  return fallback;
}

export function formatLegalDate(iso) {
  try {
    return new Date(iso).toLocaleDateString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}
